const FormError = ({ children }) => <div style={{ color: '#f44336', fontSize: 12, lineHeight: '14px' }}>{children}</div>

export default FormError
